import { UPDATE_DATA } from './constants';

const initialState = {
  currentData: {}
};

const AiContact = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DATA:
      return {
        ...state,
        currentData: action.payload
      };
    default:
      return state;
  }
};

export default AiContact;